import { render } from "./ProfileServicesQuoteComponent.vue?vue&type=template&id=0aa9113a&scoped=true"
import script from "./ProfileServicesQuoteComponent.vue?vue&type=script&lang=js"
export * from "./ProfileServicesQuoteComponent.vue?vue&type=script&lang=js"

import "./ProfileServicesQuoteComponent.vue?vue&type=style&index=0&id=0aa9113a&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa9113a"]])

export default __exports__